import { statusToTranslationKey } from "@/utils/statusBadge.utils"
import type { TagTone } from "./Tag"

export const STATUS_TONE: Record<string, TagTone> = {
    pending: "neutral",
    draft: "neutral",
    procuring: "cream",
    onHold: "cream",
    scheduled: "blue",
    open: "blue",
    sent: "blue",
    invoiceReceived: "blue",
    inTransit: "lilac",
    partialFulfilled: "peach",
    delivered: "green",
    fulfilled: "green",
    accepted: "green",
    invoicePaid: "green",
    active: "green",
    invoiceFlagged: "red",
    rejected: "red",
    running: "lilac",
    paused: "cream",
    completed: "green",
    failed: "red",
    stopped: "peach",
    cancelled: "red",
}

export const statusTone = (status: string | null | undefined): TagTone =>
    status
        ? (STATUS_TONE[statusToTranslationKey(status)] ?? "neutral")
        : "neutral"
